import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 120 121",
  "content": "<symbol viewBox=\"0 0 120 121\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-play\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M87.3211 57.8577C89.294 58.9824 89.294 61.7942 87.3211 62.9189L44.0399 87.5924C42.067 88.7172 39.6008 87.3113 39.6008 85.0618L39.6008 35.7148C39.6008 33.4653 42.0669 32.0594 44.0399 33.1841L87.3211 57.8577Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol